(function () {
  if (window.DesatadosPasos) { window.DesatadosPasos.init(); return; }
  function initDsp(root) {
    if (!root || root.dataset.dspReady) return;
    root.dataset.dspReady = '1';
    root.classList.remove('no-js');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-dsp-step]'));
    if (!steps.length) { root.classList.add('is-in'); return; }
    var track = root.querySelector('.dsp__track');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dsp-dot]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var start = parseInt(root.dataset.start, 10) || 0;
    var active = start > 0 && start <= steps.length ? start - 1 : 0;
    var userTouched = false;

    function scrollable() { return track && track.scrollWidth > track.clientWidth + 2; }

    function goTo(i, smooth) {
      if (!scrollable()) return;
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      track.scrollTo({ left: steps[i].offsetLeft - pad, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    }

    function follow() { if (!userTouched) goTo(active, true); }

    function mark(i) {
      dots.forEach(function (d, k) {
        d.classList.toggle('is-current', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }

    function set(i, fromAuto) {
      active = (i + steps.length) % steps.length;
      steps.forEach(function (s, k) {
        s.classList.toggle('is-active', k === active);
        s.classList.toggle('is-done', k < active);
        if (k === active) s.setAttribute('aria-current', 'step'); else s.removeAttribute('aria-current');
      });
      if (!scrollable()) mark(active);
      if (fromAuto) follow();
    }

    steps.forEach(function (s, k) {
      s.addEventListener('click', function () { set(k); });
      s.addEventListener('focusin', function () { set(k); });
      s.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) set(k); });
      var t = s.querySelector('[data-dsp-timer]');
      if (t) t.addEventListener('animationend', function () { if (k === active) set(active + 1, true); });
    });

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { userTouched = true; set(k); goTo(k, true); mark(k); });
    });

    if (track) {
      track.addEventListener('touchstart', function () { userTouched = true; }, { passive: true });
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (!scrollable()) return;
          var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
          var x = track.scrollLeft + pad;
          var best = 0, dist = Infinity;
          steps.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - x); if (d < dist) { dist = d; best = k; } });
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = steps.length - 1;
          mark(best);
        });
      }, { passive: true });
    }

    root.addEventListener('mouseenter', function () { root.classList.add('is-hover'); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-hover'); });

    if (root.dataset.auto === 'true' && !reduce && steps.length > 1) root.classList.add('is-auto');
    set(active);
    mark(scrollable() ? 0 : active);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) root.classList.add('is-in');
          root.classList.toggle('is-visible', e.isIntersecting);
        });
      }, { threshold: 0.3 });
      io.observe(root);
    } else {
      root.classList.add('is-in', 'is-visible');
    }
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-dsp]').forEach(initDsp); }
  window.DesatadosPasos = { init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();